import { useQuery } from "react-query";
import { getVisitConsentByToken } from "./visit-consent-public.api";
import type { RemoteApiError } from "../useRemote/types";

export function useVisitorConsentByToken(token: string | undefined) {
  return useQuery({
    queryKey: ["visitor-consent", "by-token", token],
    queryFn: async () => {
      if (!token) {
        throw new Error("Missing consent token");
      }
      const { data } = await getVisitConsentByToken(token);
      return data;
    },
    enabled: Boolean(token?.trim()),
    retry: false,
    staleTime: Number.POSITIVE_INFINITY
  });
}

export type VisitorConsentByTokenQueryError = RemoteApiError;
